var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('el-checkbox-group',{attrs:{"value":_vm._f("nil")(_vm.value,[])},on:{"input":function (val) {
        _vm.$emit('input', val);
      }}},_vm._l((_vm.options),function(opt){return _c('el-checkbox',{key:opt.value,attrs:{"label":opt.value}},[_vm._v(" "+_vm._s(opt.label)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }